<section class="raffles">
  <h2>Раффлы пользователя {{ userId }}</h2>
  <form class="filters" [formGroup]="form" (ngSubmit)="apply()">
    <mat-form-field appearance="outline"
      ><mat-label>ID раффлов</mat-label
      ><input matInput formControlName="ids" placeholder="695, 1060"
    /></mat-form-field>
    <mat-form-field appearance="outline"
      ><mat-label>Creator IDs</mat-label
      ><input matInput formControlName="creatorIds"
    /></mat-form-field>
    <mat-form-field appearance="outline"
      ><mat-label>Доступ</mat-label
      ><mat-select formControlName="accessTypes" multiple>
        <mat-option value="open">Открытый</mat-option
        ><mat-option value="private">Приватный</mat-option>
      </mat-select></mat-form-field
    >
    <mat-form-field appearance="outline"
      ><mat-label>Завершён</mat-label
      ><mat-select formControlName="raffleFinish">
        <mat-option [value]="null">Все</mat-option
        ><mat-option [value]="false">Нет</mat-option
        ><mat-option [value]="true">Да</mat-option>
      </mat-select></mat-form-field
    >
    <mat-form-field appearance="outline"
      ><mat-label>Сумма наград от</mat-label
      ><input matInput type="number" min="0" formControlName="minSumRewards"
    /></mat-form-field>
    <mat-form-field appearance="outline"
      ><mat-label>Сумма наград до</mat-label
      ><input matInput type="number" min="0" formControlName="maxSumRewards"
    /></mat-form-field>
    <mat-form-field *ngFor="let field of dates" appearance="outline">
      <mat-label>{{ field.label }} (UTC)</mat-label
      ><input matInput type="datetime-local" [formControlName]="field.key" />
    </mat-form-field>
    <div class="filter-actions">
      <button
        mat-raised-button
        color="primary"
        type="submit"
        [disabled]="loading"
      >
        Применить
      </button>
      <button mat-button type="button" (click)="reset()">Сбросить</button
      ><button mat-button type="button" (click)="reload()" [disabled]="loading">
        Обновить
      </button>
    </div>
  </form>
  <p>Даты указаны в UTC. Суммы — в единицах сервиса.</p>
  <p *ngIf="error" class="error" role="alert">{{ error }}</p>
  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
  <div class="table-scroll">
    <table
      mat-table
      [dataSource]="rows"
      matSort
      [matSortActive]="sort.active"
      [matSortDirection]="sort.direction"
      (matSortChange)="sortChanged($event)"
      matSortDisableClear
    >
      <ng-container *ngFor="let field of fields" [matColumnDef]="field.key">
        <th
          mat-header-cell
          *matHeaderCellDef
          [mat-sort-header]="field.key"
          [disabled]="!field.sort"
        >
          {{ field.label }}
        </th>
        <td mat-cell *matCellDef="let row">
          <ng-container *ngIf="field.date; else plain">{{
            dateValue(row, field.key) | date: 'dd.MM.yyyy HH:mm:ss':'UTC'
          }}</ng-container>
          <ng-template #plain>
            <a
              *ngIf="field.key === 'creatorId'; else textValue"
              [routerLink]="['/user/', row.creatorId]"
              >{{ row.creatorId }}</a
            >
            <ng-template #textValue>{{
              field.key === 'raffleFinish'
                ? row.raffleFinish
                  ? 'Да'
                  : 'Нет'
                : value(row, field.key)
            }}</ng-template>
          </ng-template>
        </td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Действия</th>
        <td mat-cell *matCellDef="let row">
          <button mat-button (click)="open(row, 'rewards')">Награды</button
          ><button mat-button (click)="open(row, 'conditions')">Условия</button>
          <button
            *ngIf="canEdit"
            mat-button
            color="warn"
            [disabled]="row.raffleFinish || mutating"
            (click)="exclude(row)"
          >
            Исключить юзера из раффла
          </button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="columns"></tr>
      <tr mat-row *matRowDef="let row; columns: columns"></tr>
    </table>

    <p *ngIf="!loading && !error && !rows.length">
      Раффлы по выбранным фильтрам не найдены.
    </p>
  </div>
  <mat-paginator
    [length]="amount"
    [pageIndex]="pageIndex"
    [pageSize]="pageSize"
    [pageSizeOptions]="[20, 50, 100]"
    (page)="page($event)"
    showFirstLastButtons
  ></mat-paginator>
</section>
